/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-07-01 14:32:23
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-09-04 19:29:04
 * @FilePath: /src/app/(payment)/payment/components/WorryFreeDelivery/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { IPrice } from '@/api/types/order';
import Switch from '@/components/Form/Switch';
import { useStore } from '@/providers/app-store-provider';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import { QuestionFilled, WorryFreeDelivery as WorryFreeDeliveryIcon } from '@zeelool/icon';

import { useMemo, useState } from 'react';
import WorryFreeDeliveryDialog from './components/WorryFreeDeliveryDialog';
import { useTranslations } from 'next-intl';

interface WorryFreeDeliveryProps {
  freightList: IPrice['freight'];
  freight: string;
  isCheckDelivery: number;
  changeDelivery: (isCheckDelivery: number) => void;
}

export default function WorryFreeDelivery({ ...props }: WorryFreeDeliveryProps) {
  const t = useTranslations('payment.WorryFreeDelivery');
  const { freightList, freight, changeDelivery } = props;

  const currency = useStore((state) => state.currency);
  const [checked, setChecked] = useState(true);
  const [open, setOpen] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    changeDelivery(event.target.checked ? 1 : 2);
  };

  const selectFreeDelivery: any = useMemo(() => {
    let data = {};
    if (freight && freightList.find((item) => item.name === freight)) {
      data = freightList.find((item) => item.name === freight).insurance || {};
    }
    return data;
  }, [freightList, freight]);

  const onConfirm = () => {
    setOpen(false);
    setChecked(true);
    changeDelivery(1);
  };

  const onCancel = () => {
    setOpen(false);
    setChecked(false);
    changeDelivery(2);
  };

  return (
    <>
      {selectFreeDelivery && +selectFreeDelivery.insurance_price ? (
        <div className="bg-white p-12 px-[1.5625vw] rounded-[10px] md:rounded-[5px] mb-12">
          <div className="flex items-center">
            <div className="flex-1 flex items-center">
              <div className="mr-4 font-bb flex items-center whitespace-nowrap text-14 md:text-16">
                <WorryFreeDeliveryIcon className="text-20 mr-4" />
                <span>
                  {t('worryFreeDelivery')}{' '}
                  <span className="font-br">
                    for {formatPriceNumberWithSymbol(selectFreeDelivery.insurance_price, currency)}
                  </span>
                </span>
              </div>
              <QuestionFilled
                onClick={() => setOpen(true)}
                className="text-auxiliary-text text-16 md:text-18 cursor-pointer"
              />
            </div>
            <div className="switch-box">
              <Switch checked={checked} onChange={handleChange} width={42} height={22} />
            </div>
          </div>
          <div className="  mt-8 text-auxiliary-text text-12 leading-18">
            {t('fullRefundIfNotArrive')}
          </div>
        </div>
      ) : null}

      <WorryFreeDeliveryDialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        onCancel={onCancel}
        onConfirm={onConfirm}
        insurancePrice={selectFreeDelivery.insurance_price}
        currency={currency}
      />
    </>
  );
}
